import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

import { ReturnIntegrationProviderSchema } from "@redotech/redo-model/return-integration-types";

export const timeSeriesGroupByValues = ["day", "week", "month"] as const;
export type TimeSeriesGroupBy = (typeof timeSeriesGroupByValues)[number];

export const timeSeriesDataPointSchema = z.object({
  date: z.string(), // ISO date string (YYYY-MM-DD)
  staleRmaReturnsCount: z.number().int().min(0),
  automationRmaProcessedCount: z.number().int().min(0),
});

export type TimeSeriesDataPoint = z.infer<typeof timeSeriesDataPointSchema>;

export const integrationTimeSeriesSchema = z.object({
  integration: ReturnIntegrationProviderSchema,
  data: z.array(timeSeriesDataPointSchema),
});

export type IntegrationTimeSeries = z.infer<typeof integrationTimeSeriesSchema>;

export const getReturnIntegrationMetricsTimeSeries = unaryRpc({
  name: "getReturnIntegrationMetricsTimeSeries" as const,
  input: z.object({
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    integrations: z.array(ReturnIntegrationProviderSchema).optional(),
    teamId: z.string().optional(),
    groupBy: z.enum(timeSeriesGroupByValues).default("day"),
  }),
  output: z.object({ series: z.array(integrationTimeSeriesSchema) }),
});

export type GetReturnIntegrationMetricsTimeSeriesInput = z.infer<
  typeof getReturnIntegrationMetricsTimeSeries.input
>;
export type GetReturnIntegrationMetricsTimeSeriesOutput = z.infer<
  typeof getReturnIntegrationMetricsTimeSeries.output
>;
